import { useState, useEffect } from "react";
import "@/App.css";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // Ping API on load to check connection
    const pingApi = async () => {
      try {
        await axios.get(`${API}/`);
        console.log("Backend API connected successfully");
      } catch (e) {
        console.error("Backend API connection error", e);
      }
    };
    pingApi();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      // Replicate production localStorage backup
      localStorage.setItem(
        "lead_data",
        JSON.stringify({
          name,
          phone,
          email,
          timestamp: new Date().toISOString(),
        })
      );

      const payload = {
        client_name: `${name} | ${phone} | ${email}`,
      };

      // Submit lead to backend status endpoint
      await axios.post(`${API}/status`, payload);
      console.log("Lead successfully stored in backend MongoDB.");
    } catch (err) {
      console.error("Error submitting lead to backend, proceeding with redirect...", err);
    } finally {
      // Update target URL to point to https://vsl.minditpro.com/
      window.location.href = "https://vsl.minditpro.com/";
    }
  };

  return (
    <div className="App">
      <main>
        <section id="hero" className="hero hero-plain">
          <div className="wrap hero-grid">
            {/* Left/Photo Column */}
            <div className="hero-photo-col">
              <div className="hero-photo-glow" aria-hidden="true"></div>
              <img
                className="hero-photo-img"
                src="https://thealignmentcodemind.minditpro.com/vasavi-lakhani.png"
                alt="Vasavi Lakhani, Psychologist and Alignment Expert, seated at her desk in front of a framed Alignment Code poster"
                data-testid="hero-photo"
              />
              <p className="photo-caption" data-testid="hero-photo-caption">
                <strong>Vasavi Lakhani</strong>
                <br />
                Psychologist &amp; Alignment Expert
              </p>
            </div>

            {/* Right/Content Column */}
            <div className="hero-content-col">
              <p className="kicker" data-testid="hero-kicker">
                India’s First &amp; Only System to “Align Your Mind, Body, Emotions, Nervous System, Identity &amp; Action”
              </p>
              <h1 data-testid="hero-heading">
                The Alignment Code<span className="tm">™</span>
              </h1>
              <p className="subhead" data-testid="hero-subhead">
                Build SUCCESS that is STABLE &amp; SUSTAINABLE using my proven “6D Alignment Framework”
              </p>
              <p className="eyebrow" data-testid="hero-eyebrow">(for ambitious &amp; busy professionals, coaches &amp; business owners)</p>
              <p className="tagline">Don’t fix yourself in pieces, be at peace with all parts of your life.</p>
              <p className="method-line">Using human behavior, psychology &amp; neuroscience.</p>
              <div className="gold-rule" aria-hidden="true"></div>
              
              {/* Form Card */}
              <div className="hero-form-card">
                <p className="form-lead" data-testid="form-lead-text">
                  Book a free 60-minute discovery call and find out exactly where your gap is — and how The Alignment Code closes it, for good.
                </p>
                <form
                  className="lead-form"
                  id="lead-form"
                  data-testid="lead-capture-form"
                  onSubmit={handleSubmit}
                >
                  <div className="field">
                    <input
                      id="lead-name"
                      name="Name"
                      type="text"
                      aria-label="Full Name"
                      placeholder="Full Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      data-testid="lead-name-input"
                    />
                  </div>
                  <div className="field">
                    <input
                      id="lead-email"
                      name="Email"
                      type="email"
                      aria-label="Email Address"
                      placeholder="Email Address"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      data-testid="lead-email-input"
                    />
                  </div>
                  <div className="field">
                    <input
                      id="lead-phone"
                      name="Phone Number"
                      type="tel"
                      aria-label="Phone Number"
                      placeholder="Phone Number"
                      required
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      data-testid="lead-phone-input"
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary btn-full"
                    disabled={isSubmitting}
                    data-testid="lead-form-submit-button"
                  >
                    {isSubmitting ? "Submitting..." : "Book My Free Discovery Call"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default App;